import { Button, Panel, PanelBody, PanelHeader } from "@itandi/itandi-bb-ui";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { NotificationModal } from "~/components/common/notifications/settings/NotificationModal";
import { NotificationSetting } from "~/components/specifics/settings/notifications/NotificationSetting";
import { useCompanyNotifications } from "~/hooks/useCompanyNotifications";
import { useStatuses } from "~/hooks/useStatuses";
import { useSubtypes } from "~/hooks/useSubtypes";
import type { NotificationEdit } from "~/models/Notification";
import { isSuccess } from "~/utils/api/api_handler";
import { create } from "~/utils/api/CompanyNotification";

export function Page() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { data: notifications, mutate: mutateNotifications } =
		useCompanyNotifications().index();
	const { data: statuses } = useStatuses().index();
	const { data: subtypes } = useSubtypes().useIndex();

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const handleAcceptSubmit = useCallback(
		async (notification: NotificationEdit) => {
			const response = await create(notification);
			if (isSuccess(response)) {
				await mutateNotifications();
				setIsModalOpen(false);
				toast.success("通知設定を追加しました。");
			} else {
				toast.error("通知設定の追加に失敗しました。");
			}
		},
		[mutateNotifications]
	);

	if (notifications === null || statuses === null || subtypes === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader
						rightArea={
							<Button onClick={handleOpenModal} variant="primary">
								追加
							</Button>
						}
						title="通知設定"
					/>
					<PanelBody>
						<NotificationSetting
							notifications={notifications}
							statuses={statuses}
							subtypes={subtypes}
						/>
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
			{isModalOpen ? (
				<NotificationModal
					handleAcceptSubmit={handleAcceptSubmit}
					handleClose={handleCloseModal}
					lineUserAccounts={null}
					statuses={statuses}
					subtypes={subtypes}
					type="CompanyNotification"
					useLineNotification={false}
				/>
			) : null}
		</DefaultV2>
	);
}
